<template>
    <div class="myhie-cta" v-if="items.length">
        <h2>Related authors</h2>
        <div class="related-authors">
            <div class="item" v-for="item in items" :key="item.Id">
                <div class="headshot">
                    <img :src="getAuthorImage(item.ImageUrl)" alt="">
                </div>

                <div class="e-text">
                    <h3>{{item.FullName}}</h3>
                    <p>{{item.JobTitle}}</p>
                    <a :href="item.Url">View posts</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Axios from 'axios'

    export default {

        created() {
            this.getItems()
        },

        data() {
            return {
                items: []
            }
        },

        methods: {
            getItems() {
                Axios.get('/umbraco/api/BlogApi/RelatedAuthors', { params: { pageId: currentPageId } })
                    .then((response) => {
                        if (response.status == 200) {
                            this.items = response.data
                        }
                    })
            },

            getAuthorImage(path) {
                return path + '?width=82&height=82&mode=crop'
            }
        }
    }
</script>